import React, { useEffect, useState } from "react";
import "./LearnMore.scss";

import { MdLock } from "react-icons/md";
import { FaCheck } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { FaPlus, FaMinus } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import ROUTES from "../../../constants/routes";
import { useSelector } from "react-redux";
import { useViewPortDetector } from "../../../helpers/viewPortDetector";

const faqs = [
  {
    title: "Question 1",
    desc: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Officia ratione blanditiis, asperiores sint nesciunt doloribus deleniti alias repellat, neque consequuntur hic molestias quasi, quibusdam pariatur voluptatibus laboriosam quis ab optio fugit dolorum vel! Tempora, quam temporibus?",
  },
  {
    title: "Question 2 hello world?",
    desc: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Officia ratione blanditiis, asperiores sint nesciunt doloribus deleniti alias repellat, neque consequuntur hic molestias quasi, quibusdam pariatur voluptatibus laboriosam quis ab optio fugit dolorum vel! Tempora, quam temporibus?",
  },
];

const LearnMore = ({ desktopView }) => {
  const { currentViewPort, isReady } = useViewPortDetector();
  const { plans } = useSelector((state) => state.subscriptionReducer.value);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [features, setFeatures] = useState([]);

  const [headings, setHeadings] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    if (!desktopView && currentViewPort === "desktop" && isReady) {
      navigate(ROUTES.upgrade.path);
    }
  }, [desktopView, currentViewPort, isReady]);

  useEffect(() => {
    if (Array.isArray(plans) && plans.length > 0) {
      const featureArray = [];
      const headingArray = [];

      plans.forEach((plan) => {
        const planDetails = {
          name: plan?.name || "N/A",
          plan_id:
            plan?.pricing?.monthly?.id ||
            plan?.pricing?.yearly?.id ||
            "N/A",
        };
        headingArray.push(planDetails);

        (plan?.features || []).forEach((feature) => {
          const existingFeature = featureArray.find(
            (item) => item?.feature_id === feature?.feature_id
          );

          if (!existingFeature) {
            const newFeature = {
              ...feature,
              [`${planDetails.plan_id}`]: feature?.value || true,
            };
            featureArray.push(newFeature);
          } else {
            existingFeature[`${planDetails.plan_id}`] = feature?.value || true;
          }
        });
      });

      setHeadings(headingArray);
      setFeatures(featureArray);
    } else {
      setFeatures([]);
      setHeadings([]);
    }
  }, [plans]);

  return (
    <div className="upgrade-learn-more">
      <div className="heading">
        <p>Boost Your Productivity With Expanded Access</p>
      </div>

      <div className="main-content">
        <table>
          <thead>
            <tr>
              <th className="title">Plans</th>
              {headings.map((el, i) => {
                return <th key={i}>{el?.name}</th>;
              })}
            </tr>
          </thead>

          <tbody>
            {features?.map((el, i) => {
              return (
                <tr key={i}>
                  <td className="title">{el?.name}</td>

                  {headings?.map((item, i) => {
                    const featureExists = el[`${item?.plan_id}`] || false;

                    return (
                      <td key={i}>
                        {featureExists ? (
                          featureExists === true ? (
                            <FaCheck />
                          ) : (
                            `${el[`${item?.plan_id}`]} ${
                              el?.tag === "analytics" ? "days filter" : ""
                            }`
                          )
                        ) : (
                          <IoClose className="close" />
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>

        <div className="middle">
          <img
            className="card-list"
            src="/images/upgrade/cards.svg"
            alt="" aria-label="Paypal MasterCard VisaCard"
          />

          <p className="desc">
            Depending on where you live you may be charged taxes in addition to
            your subscription price.
          </p>

          <Link to={ROUTES.upgrade.path}>Back to our Plans</Link>
        </div>

        <div className="faqs">
          <p className="title">FAQ</p>

          <div className="list">
            {faqs.map((el, i) => {
              return (
                <div
                  className="item"
                  key={i}
                  onClick={() => {
                    if (selectedIndex !== i) {
                      setSelectedIndex(i);
                    } else {
                      setSelectedIndex(null);
                    }
                  }}
                >
                  <p>
                    {el.title} {selectedIndex === i ? <FaMinus /> : <FaPlus />}{" "}
                  </p>
                  <div
                    className={`answer ${selectedIndex === i ? "active" : ""}`}
                  >
                    <span>{el.desc}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LearnMore;
